// Vendeor
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

import { API_ADMIN_URL } from 'Defaults'

// App Components
import SvgIcon from 'Components/SvgIcon'
import AppLink from 'Components/AppLink'
import WithSpinner from 'Components/WithSpinner'
import { COLLAPSE_TYPES } from 'Utils/navigationUtils'
import ContactAgentGeneric from 'Components/ContactAgentGeneric'
import PreconInsiderAccess from './components/PreconInsiderAccess'
// Styles

import {
  _AdminButtons,
  _BuildingInfoWrapper,
  _BuildingInfoInner,
  _BuildingInfo,
  _BuildingTitleContainer,
  _SaleRentCountBlocks,
  _SvgAnchorContainer,
  _AnchorContainer,
  _AnchorDivider,
  _Title,
  _TitlePlaceHolder,
  _AddressDeveloperContainer,
  _PreconTag,
  // _MarkerWithAddress,
  // _AddressPlaceHolder,
  _Developer,
  _Link,
  _SaleRentBlock,
  _ButtonTextContainer,
  _ButtonText,
  _Count,
  _AnchorText,
  _ContactAgentContainer,
  _PreconContainer,
  _PreconSubtext,
  _MiddleSection,
  _PreconStatusContainer,
  _Architect,
} from './styles'


const BuildingInfo = ({
  building,
  isPrecon,
  optimizedFor,
  userIsAdmin,
  onInfoBoxAnchorClick,
  isMobileApp,
  isFetching,
  pageSpinnerCss,
  agent,
  handleContactAgentClick,
  googleAnalyticsEvent,
}) => {
  if(!building) return ''

  const [clientSideMounted, setClientSide] = useState(false)
  useEffect(() => {
    setClientSide(true)
  }, [])
  const handleContactAgent = () => {
    handleContactAgentClick({ agent })
  }

  const onLinkClick = (linkName) => {
    googleAnalyticsEvent({
      category: isPrecon ? 'precon building' : 'building',
      action: `[${linkName} Link Click]`,
    })
  }

  const title = building && building?.name
  const saleStatus = building && building.sales_status
  const priceMin = building && building.price_min
  const priceMax = building && building.price_max
  const architect = building && building.architects && building.architects[0]
  // const address =
  //   building &&
  //   (building.addresses_string ||
  //     (building.primary_address && building.primary_address.title))
  const developer = building && building.developers && building.developers[0]
  const forSaleCount =
    building && building.listings && building.listings?.for_sale?.length
  const forRentCount =
    building && building.listings && building.listings?.for_rent?.length

  const preconForSaleCount = building?.listings?.precon_for_sale?.length || 0


  const nameAsH1 = !optimizedFor || optimizedFor === 'Name'
  const MainHeader = nameAsH1 ? 'h1' : 'h2'
  // const SecHeader = !nameAsH1 ? 'h1' : 'h2'

  let buildingUrl = API_ADMIN_URL
  if(typeof window !== 'undefined') {
    buildingUrl = `${API_ADMIN_URL}building/${building &&
    building.id}/general`
  }
  const devElem = !isMobileApp && developer && developer.active ? Link : 'span'
  const archElem = !isMobileApp && architect && architect.active ? Link : 'span'
  // const showListing = forSaleCount || forRentCount
  const showSpinner = isFetching && !building

  return (
    <_BuildingInfoWrapper>
      <_AdminButtons>
        {clientSideMounted && userIsAdmin && (
          <div>
            <AppLink openNewTab to={buildingUrl}>
              <SvgIcon name="#icon-edit-dark" width={25} height={25} />
            </AppLink>
          </div>
        )}
      </_AdminButtons>
      <_BuildingInfo userIsAdmin={userIsAdmin} isPrecon={isPrecon}>
        <_PreconStatusContainer>
          <_BuildingInfoInner isPrecon={isPrecon}>
            <_PreconTag isPrecon={isPrecon}>Pre-construction</_PreconTag>
            <_BuildingTitleContainer>
              <_Title as={MainHeader}>
                {title || (
                <_TitlePlaceHolder />
                )}
              </_Title>
            </_BuildingTitleContainer>
            <_AddressDeveloperContainer>
              {developer && (
              <_Developer>
                <span>Builder: </span>
                {
                  <_Link
                    as={devElem}
                    to={'/' + developer?.url}
                    onClick={() => onLinkClick('developer')}
                  >
                    {developer?.name}
                  </_Link>
                }
              </_Developer>
              )}
              {developer && isPrecon && (
              <_Architect>
                <span>Architect: </span>
                {
                  <_Link
                    as={archElem}
                    to={'/' + architect?.url}
                    onClick={() => onLinkClick('architect')}
                  >
                    {architect?.name || '-'}
                  </_Link>
                }
              </_Architect>
              )}
            </_AddressDeveloperContainer>
          </_BuildingInfoInner>
          <_MiddleSection isPrecon={isPrecon}>
            {
            showSpinner ? (
              <WithSpinner
                showSpinner={showSpinner}
                spinnerContClass={pageSpinnerCss}
              />
            ) : isPrecon ? (
              <_PreconContainer>
                <_PreconSubtext>
                  <span>Construction Status: </span>{building?.construction_status || '-'}
                </_PreconSubtext>
                <_PreconSubtext><span>Selling Status: </span>  {saleStatus || '-'}</_PreconSubtext>
                <_PreconSubtext><span>Occupancy: </span> {building?.occupancy_date || '-'}</_PreconSubtext>
              </_PreconContainer>
            ) : (
              <_SaleRentCountBlocks>
                <_SaleRentBlock
                  onClick={() => onInfoBoxAnchorClick(COLLAPSE_TYPES.FOR_SALE)}
                >
                  <_ButtonTextContainer>
                    <_Count>{forSaleCount || 0}&nbsp;</_Count>
                    <_ButtonText>{COLLAPSE_TYPES.FOR_SALE}</_ButtonText>
                  </_ButtonTextContainer>
                </_SaleRentBlock>
                <_SaleRentBlock
                  onClick={() => onInfoBoxAnchorClick(COLLAPSE_TYPES.FOR_RENT)}
                >
                  <_ButtonTextContainer>
                    <_Count>{forRentCount || 0}&nbsp;</_Count>
                    <_ButtonText>{COLLAPSE_TYPES.FOR_RENT}</_ButtonText>
                  </_ButtonTextContainer>
                </_SaleRentBlock>
              </_SaleRentCountBlocks>
            )
          }
            {!isPrecon && (
            <_SvgAnchorContainer>
              <_AnchorContainer>
                <_AnchorText
                  onClick={() => onInfoBoxAnchorClick(COLLAPSE_TYPES.PRICE_HISTORY)}
                >
                  {COLLAPSE_TYPES.PRICE_HISTORY}
                </_AnchorText>
                <_AnchorDivider>|</_AnchorDivider>
                <_AnchorText
                  onClick={() => onInfoBoxAnchorClick(COLLAPSE_TYPES.NEARBY_SCHOOLS)}
                >
                  Nearby Schools
                </_AnchorText>
              </_AnchorContainer>
            </_SvgAnchorContainer>
            )}
          </_MiddleSection>
        </_PreconStatusContainer>
        { isPrecon ?
          <PreconInsiderAccess
            agent={agent}
            handleContactAgent={handleContactAgent}
            saleStatus={saleStatus}
            priceMax={priceMax}
            priceMin={priceMin}
            units={preconForSaleCount}
            onInfoBoxAnchorClick={onInfoBoxAnchorClick}
            COLLAPSE_TYPES={COLLAPSE_TYPES}
          />
          :
          <_ContactAgentContainer isPrecon={isPrecon}>
            <ContactAgentGeneric
              agent={agent}
              handleContactAgent={handleContactAgent}
              gaCategory={'Building'}
              requestInfo={false}
            />
          </_ContactAgentContainer>}
      </_BuildingInfo>
    </_BuildingInfoWrapper>
  )
}

BuildingInfo.propTypes = {
  building: PropTypes.shape({
    addresses_string: PropTypes.string,
    _geoloc: PropTypes.arrayOf(PropTypes.number),
    listings_for_sale_count: PropTypes.number,
    listings_for_rent_count: PropTypes.number,
    primary_address: PropTypes.shape({
      title: PropTypes.string,
    }),
    id: PropTypes.number,
    listings: PropTypes.shape({
      for_sale: PropTypes.arrayOf(PropTypes.shape({})),
      for_rent: PropTypes.arrayOf(PropTypes.shape({})),
      precon_for_sale: PropTypes.arrayOf(PropTypes.shape({})),
    }),
    developers: PropTypes.arrayOf(PropTypes.shape({})),
    architects: PropTypes.arrayOf(PropTypes.shape({})),
    url: PropTypes.string,
    name: PropTypes.string,
    address_name: PropTypes.string,
    locality_name: PropTypes.string,
    property_management: PropTypes.shape({
      name: PropTypes.string,
    }),
    developer: PropTypes.shape({
      name: PropTypes.string,
    }),
    corp: PropTypes.shape({
      corp_number: PropTypes.string,
      condo_corp: PropTypes.string,
    }),
    date_built: PropTypes.arrayOf(PropTypes.shape({})),
    smallest_unit: PropTypes.number,
    largest_unit: PropTypes.number,
    storeys: PropTypes.string,
    units: PropTypes.string,
    floorplan: PropTypes.number,
    dates: PropTypes.arrayOf(PropTypes.shape({
      exact_date: PropTypes.string,
    })),
    price_min: PropTypes.number,
    price_max: PropTypes.number,
    sales_status: PropTypes.string,
    construction_status: PropTypes.string,
    occupancy_date: PropTypes.string,
  }),
  handleContactAgentClick: PropTypes.func,
  onInfoBoxAnchorClick: PropTypes.func,
  isPrecon: PropTypes.bool,
  userIsAdmin: PropTypes.bool,
  agent: PropTypes.shape({}),
  optimizedFor: PropTypes.string,
  googleAnalyticsEvent: PropTypes.func,
  isMobileApp: PropTypes.bool,
  isFetching: PropTypes.bool,
  pageSpinnerCss: PropTypes.string,
}
export default BuildingInfo
